<template>
    <div class="header-content-wrapper d-flex align-items-center">
        <button @click="toggleNavigation" class="burger-menu">
            <img src="@/assets/images/navigationImages/menu.svg" alt="menu Button">
        </button>
        <ul class="d-flex justify-content-end gap-4 header-ul">
            <li class="header-li profile" title="">
                <img v-if="this.$store?.userInfo?.office?.organization?.logo" :src="this.$store?.userInfo?.office?.organization?.logo" alt="logo">
            </li>
            <li class="header-li" @click="logout">
                <img src="@/assets/images/logout.svg" alt="logout">
            </li>
        </ul>
    </div>
</template>
<!-- <li class="header-li">
    <img src="@/assets/images/settingsIcon.svg" alt="settings" title="პარამეტრები">
</li>
<li class="header-li">
    <img src="@/assets/images/notificationIcon.svg" alt="settings" title="შეტყობინებები">
</li> -->
<script>
export default {
    data(){
        return {

        }
    },
    methods: {
        toggleNavigation(){
            this.$store.dispatch("toggleNavigation");
        },
        logout(){
            this.$store.dispatch("logout");
        }
    }
}
</script>
<style scoped>
.header-content-wrapper{
    padding: 10px 2.5em;
    background-color: var(--secondary-background-color);
    justify-content: flex-end;
}
.header-content-wrapper .header-ul .header-li{
    cursor: pointer;
    display: grid;
    place-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: var(--main-background-color);
}
.header-li img{
    width: 16px;
    height: 16px;
}
.header-content-wrapper .header-ul .header-li.profile{
    background-color: var(--middle-blue);
}
.burger-menu{
    display: none;
}
.burger-menu img{
    width: 30px;
    background-color: transparent;
}
@media screen and (max-width: 1700px) {
    .header-content-wrapper{
        justify-content: space-between;
    }
    .burger-menu{
        display: block;
    }
}
</style>